<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-row>
      <b-col md="6" sm="12">
        <b-card header="Voeg bestanden toe">
          <b-form @submit.prevent="uploadFile">
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group label="Voeg nieuw bestand toe">
                  <b-form-file multiple v-model="newDocumentFile" required></b-form-file>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="submit" variant="success">Upload!</b-button>
          </b-form>
        </b-card>
      </b-col>

      <b-col md="6" sm="12">
        <b-card header="Voeg video's toe">
          <b-form @submit.prevent="addVideo">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Vimeo link">
                  <b-form-input type="text" required v-model="url"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="submit" variant="success">Opslaan</b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <template #overlay>
      <div class="text-center">
        <b-spinner label="Spinning"></b-spinner>
        <p>Bestanden worden verwerkt...</p>
        <!-- We add an SR only text for screen readers -->
        <span class="sr-only">Bestanden worden verwerkt...</span>
      </div>
    </template>
  </b-overlay>

</template>

<script>
import {uploadData, addData} from "../../../api";
export default {
  //components: {Documents},
  props: {options: null},

  data() {
    return {
      overlay: false,
      newDocumentName: null,
      newDocumentFile: null,
      url: null,
    };
  },
  methods: {

    uploadFile() {
      let formData = new FormData();


      formData.append('collection', this.newDocumentName);
      for (let i = 0; i < this.newDocumentFile.length; i++) {
        console.log(this.newDocumentFile);
        if(this.newDocumentFile[i]['type'] === 'application/pdf') {
          formData.append('project_files[]', this.newDocumentFile[i])
        } else {
          formData.append('project_images[]', this.newDocumentFile[i])
        }
      }
      this.overlay = true
      uploadData(`projects/${this.$route.params.id}/media`, formData).then(({data}) => {
        this.overlay = false;
        this.newDocumentFile = null;
        this.newDocumentName = null;
        //this.model = data.data;

        this.$emit('uploadedFiles', data);

      });

    },

    addVideo() {
      this.overlay = true;

      addData(`projects/${this.$route.params.id}/videos`, {
        url: this.url
      }).then(response => {
        this.overlay = false;
        this.url = null;

        this.$emit('addedVideo', response.data.data)
      })

    }
  }
}
</script>
